import {
  GET_LAST_TASK,
  GET_LAST_TASK_SUCCESS,
  GET_LAST_TASK_ERROR,
} from "./actionTypes";

export const getLastTask = (user) => {
  return {
    type: GET_LAST_TASK,
    payload: { user },
  };
};

export const getLastTaskSuccess = (lastTask, message) => {
  return {
    type: GET_LAST_TASK_SUCCESS,
    payload: { lastTask, message },
  };
};

export const getLastTaskError = (msg) => {
  return {
    type: GET_LAST_TASK_ERROR,
    payload: msg,
  };
};
